import WatchLive from "../../pages/WatchLive";

const AdminRoutes = [
    {
        path: "/watch",
        component: WatchLive,
    }
]

export default AdminRoutes